import React from 'react';

import { useDiscountWizard } from './discount-wizard/use-discount-wizard';
import { DiscountWizard } from './discount-wizard/wizard';
import { useSmartTagWizard } from './smart-tag-wizard/use-smart-tag-wizard';
import { SmartTagWizard } from './smart-tag-wizard/wizard';

export function WizardManager(): JSX.Element {
  const {
    isWizardActive: isDiscountWizardActive,
    discountId,
    initialState: discountInitialState,
    showNotificationLink,
    hideDiscountWizard,
  } = useDiscountWizard();

  const {
    isWizardActive: isSmartTagWizardActive,
    smartTagId,
    initialState: smartTagInitialState,
    hideSmartTagWizard,
  } = useSmartTagWizard();

  return (
    <>
      <DiscountWizard
        discountId={discountId}
        initialState={discountInitialState}
        isWizardActive={isDiscountWizardActive}
        showNotificationLink={showNotificationLink}
        onClose={hideDiscountWizard}
      />

      <SmartTagWizard
        initialState={smartTagInitialState}
        isWizardActive={isSmartTagWizardActive}
        smartTagId={smartTagId}
        onClose={hideSmartTagWizard}
      />
    </>
  );
}
